import { motion } from 'motion/react';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';

interface MotionPortfolioProjectCardProps extends PropsWithChildren {
  className?: string;
  title: string;
}

export const MotionPortfolioProjectCard = ({
  children,
  className,
  title,
}: MotionPortfolioProjectCardProps) => {
  return (
    <MotionPortfolioProjectCardWrapper
      layout
      key={title}
      className={className}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: ANIMATION_CONFIG.portfolioProjects.duration,
      }}
    >
      {children}
    </MotionPortfolioProjectCardWrapper>
  );
};

const MotionPortfolioProjectCardWrapper = styled(motion.div)``;
